import { cn } from '../../../utils/string/cn.utils';

const ButtonIconGhostSmall = ({ id, icon, active = false, ...props }) => {
  return (
    <button
      id={id}
      type="button"
      {...props}
      className={cn(
        'flex justify-center items-center rounded-[100px] text-black-medium hover:bg-primary-primaryVarient1 hover:text-white-high disabled:text-[#ACACAC] cursor-pointer disabled:cursor-not-allowed',
        'w-[24px] h-[24px] p-[2px]',
        active && 'bg-primary-primary text-white-high',
        props.className
      )}
    >
      {icon && (
        <div className="w-18 h-18 flex justify-center items-center">{icon}</div>
      )}
    </button>
  );
};

export default ButtonIconGhostSmall;
